import { useState } from 'react';
import { usePageTitle } from '@/shared/usePageTitle';
import { PageHeader } from '@/shared/PageHeader';
import { MonthlyChart, YearlyChart } from './InterventionsCharts';

export function ChartsPage(): React.JSX.Element {
  usePageTitle('Grafici Interventi');
  const currentYear = new Date().getFullYear();
  const [year, setYear] = useState(currentYear);
  const years = Array.from({ length: 10 }, (_, i) => currentYear - i);

  return (
    <div className="page-container">
      <PageHeader title="📊 Grafici Interventi"
        actions={(
          <>
            <label style={{ fontSize: 14, color: '#666', fontWeight: 600 }}>Anno:</label>
            <select value={year} onChange={e => setYear(parseInt(e.target.value, 10))}
              style={{ padding: '8px 12px', borderRadius: 8, border: '1px solid #ced4da' }}>
              {years.map(y => <option key={y} value={y}>{y}</option>)}
            </select>
          </>
        )} />

      <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: 24, marginTop: 20 }}>
        <div style={{ background: '#fff', padding: 24, borderRadius: 10, boxShadow: '0 2px 8px rgba(0,0,0,0.05)', minWidth: 0 }}>
          <h3 style={{ marginTop: 0 }}>Andamento mensile ({year})</h3>
          <MonthlyChart year={year} />
        </div>
        <div style={{ background: '#fff', padding: 24, borderRadius: 10, boxShadow: '0 2px 8px rgba(0,0,0,0.05)', minWidth: 0 }}>
          <h3 style={{ marginTop: 0 }}>Andamento annuale</h3>
          <YearlyChart />
        </div>
      </div>
    </div>
  );
}
